import { Box, Container } from "@mui/material";
import React, { FC } from "react";
import useResponsive from "../hooks/useResponsive";

export const ContentLayout: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Container sx={{}}>
      <Box
        sx={{
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Container>
  );
};

export const ContentMainLayout: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isDesktop = useResponsive("down", "lg", "xl");
  return (
    <Container sx={{}}>
      <Box
        sx={{
          width: isDesktop ? "100%" : "90%",
          marginLeft: isDesktop ? "0px" : "120px",
        }}
      >
        {children}
      </Box>
    </Container>
  );
};
